module.exports = {"values":{"want help?":"7ab n3awnouk ? ","contact us":"contactina ","or":"oula ","call us":"3ayetelna "}}


//////////////////
// WEBPACK FOOTER
// ./src/language/de.json
// module id = 841
// module chunks = 0